let $ = require('jquery');
let Backbone = require("backbone");
let POS = require("../POS.js");
import _ from "underscore";
let i18n = require("i18next");

let main = function () {
    var NetworkCheckView = Backbone.View.extend({
        el: "#networkCheckModal",
        events: {},
        initialize: function (options) {
            this.model = options.model;
            this.model.on("change:done", () => {
                this.hide();
            });
            _.delay(() => {
                if (!this.model.get('done') && !this.model.get('error')) {
                    this.show();
                } else {
                    this.hide();
                }
            }, 10 * 1000);
        },
        show: function () {
            console.log("showing network check view");
            this.$el.removeClass("hidden");
            this._startNetworkCheck();
        },
        hide: function () {
            this.$el.addClass("hidden");
        },
        _startNetworkCheck: function () {
            this.$(".progress-bar").css("width", '30%').addClass('active').addClass('progress-bar-primary').removeClass('progress-bar-danger').text(i18n.t("pos.network.checking"));
            this.$(".btn").addClass('.btn-primary').removeClass('btn-danger');
            $.ajax({
                type: 'GET',
                url: '/pos/networkTest',
                data: {},
                xhr: () => {
                    var xhr = new window.XMLHttpRequest();
                    xhr.addEventListener("progress", (evt) => {
                        if (evt.lengthComputable) {
                            var percentComplete = evt.loaded / evt.total * 100;
                            console.log("download percentage completed", percentComplete);
                            this.$(".progress-bar").css("width", percentComplete + '%');
                        }
                    }, false);
                    return xhr;
                }
            })
                .done(() => {
                    this.$(".progress-bar").css("width", '100%').text(i18n.t("pos.network.done"));
                })
                .fail(() => {
                    this.$("h1").text(i18n.t("pos.network.dead"));
                    this.$(".progress-bar").css("width", '100%').removeClass('active').removeClass('progress-bar-primary').addClass('progress-bar-danger').text(i18n.t("pos.network.failed"));
                    this.$(".btn").removeClass('.btn-primary').addClass('btn-danger');
                });
        }
    });

    return NetworkCheckView;
};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/NetworkCheckView.js